import React from 'react';

import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import PDPSelectUpholsteryDecideLaterUI from './PDPSelectUpholsteryDecideLaterUI';

const PDPSelectUpholsteryDecideLater = () => {
  const productDetails = usePDPBasicDetails();

  return (
    <PDPSelectUpholsteryDecideLaterUI
      promotion={productDetails?.data?.meta?.promotion}
      excludeFromSale={productDetails?.data?.exclude_from_sale}
    />
  );
};

export default PDPSelectUpholsteryDecideLater;
